// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "e348734046e0a3ab962eb7981765e9a3" + ".css";
};